/** One figure on the QR card: a label, a large value and a small note. */
export function QrStat({ label, value, note }: { label: string; value: string; note: string }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div className="nb-eyebrow" style={{ fontSize: 9.5 }}>
        {label}
      </div>
      <div
        className="nb-tabular"
        style={{
          fontSize: 20,
          fontWeight: 800,
          lineHeight: 1.1,
          marginTop: 2,
          color: 'var(--nb-ink)',
        }}
      >
        {value}
      </div>
      <div style={{ fontSize: 10.5, color: 'var(--nb-muted)', marginTop: 2 }}>{note}</div>
    </div>
  );
}
